import * as React from 'react';

const Minus16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.25 7.25H2.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5" }));
Minus16.Size = 16;
Minus16.Title = "Minus";

export { Minus16 as default };
